import { gql } from '@apollo/client';

export const CHANGE_CURATOR_ROLE = gql`
  mutation updateUserRoles(
    $user: String!
    $isCurator: Boolean
    $isVideo: Boolean
  ) {
    updateUserRoles(user: $user, isTeam: $isCurator, isVideo: $isVideo) {
      success
      message
    }
  }
`;
